<template>
  <li class="row">
    <div class="col-xs-4 col-sm-12">
      <img :src="user.profile_image_url" />
      <span class="position">{{ priority }}</span>
    </div>
    <div class="col-xs-8 col-sm-12">
      <div class="description">
        <h4>{{ user.name }}</h4>
        <p>{{ user.profile.tagline }}</p>
        <p v-if="!$hideSocialMediaReferences" :title="`${user.profile.highest_followers} followers`">
          <i :class="['fab', user.profile.highest_followers_icon]"></i> {{ user.profile.highest_followers | abbreviatedNumber }} followers
        </p>

        <a href="" @click.prevent="handleRemoveCallback">
          Remove
          <i v-if="removingShortlistedTalent" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
        </a>
      </div>
    </div>
  </li>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { alert, notify } from 'utils'

export default {
  props: {
    user: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      removingShortlistedTalent: false
    }
  },

  computed: {
    ...mapState('booking/request/vetting', { booking: 'request' }),

    /**
     * Because talent can be removed from the shortlist we'll temporarily use the index
     * of the talent within the array of shortlisted talent to determine their
     * priority to save having to update all talent if we remove a single one.
     *
     * NOTE: This will probably have to change if we need to implement the ability to
     * re-order shortlists or add new talent to the shortlist.
     *
     * @return int
     */
    priority () {
      return this.index + 1
    }
  },

  methods: {
    ...mapActions('booking/request/vetting', [
      'deleteVettingBookingRequestShortlistedTalent',
      'removeVettingBookingRequestShortlistedTalent'
    ]),

    /**
     * Handle removing a talent from the shortlist.
     *
     * @return Promise
     */
    handleRemoveCallback () {
      if (this.removingShortlistedTalent) {
        return Promise.resolve()
      }

      this.removingShortlistedTalent = true

      return alert.confirm({
        title: 'Remove Shortlisted Talent',
        text: `Are you sure you want to remove ${this.user.name} from the shortlist?`,
        buttons: {
          confirm: {
            text: 'Yes, remove talent.'
          }
        }
      }).then(() => {
        const payload = {
          id: this.booking.id,
          talentId: this.user.id
        }

        return this.deleteVettingBookingRequestShortlistedTalent(payload)
          .then(() => {
            notify.success(`${this.user.name} was removed from the shortlist.`)
          })
          .then(() => {
            this.removeVettingBookingRequestShortlistedTalent(this.user.id)
          })
      }).catch((error) => {
        this.removingShortlistedTalent = false

        if (error.response && error.response.data.message) {
          notify.error(error.response.data.message)
        }
      })
    }
  }
}
</script>
